<template>
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="广告位名称" prop="name" :rules="[{ required: true, message: '请输入广告位名称', trigger: 'blur' }]">
      <el-input v-model="form.name" placeholder="请输入广告位名称" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="广告位示例">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.image" class="img">
            <img :src="form.image" width="150" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="联盟币价格（/天）" prop="price">
        <el-input-number v-model="form.price" :min="0"  label="金额"></el-input-number>
      </el-form-item>
      <el-form-item label="积分价格（/天）" prop="points">
        <el-input-number v-model="form.points" :min="0"  label="金额"></el-input-number>
      </el-form-item>
      <el-form-item label="广告数量" prop="adv_limit">
       <el-input-number v-model="form.adv_limit" :min="1"  label="数量"></el-input-number>
      </el-form-item>
      <el-form-item label="广告排队数" prop="adv_wait">
        <el-input-number v-model="form.adv_wait" :min="1"  label="数量"></el-input-number>
      </el-form-item>
       <el-form-item label="说明">
        <el-input v-model="form.content" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="广告位状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>

  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload,
  },
  data() {
     

    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) =>{
    	if(value<1){
    		return callback(new Error('请上传活动图'));
    	}else{
         callback();
    	}
    };

    return {
      /* 上传类型 */
      uploadtype:'',
      /* 是否打开其他上传 */
      isOtherUpload:false,
       /*是否打开添加弹窗*/
      open_add: false,
      /*是否上传图片*/
      isupload: false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传', trigger: 'change' }]
    };
  },
  props: {
    form: Object,
    app_id:Number,
    is_edit:Boolean
  },
  methods: {
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      console.log(e)
      if (e != null && e.length > 0) {
        this.form.image = e[0].file_path;
      }
      this.isupload = false;
    },
    /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },

      /* 打开上传 */
      openUploads(e) {
        this.uploadtype = e.type;
        this.isOtherUpload  = true;

      },
      /* 删除图片 */
      deleteImg(type){
        if(type=='poster'){
          this.form.poster='';
        }
        if(type=='wxqrcode'){
          this.form.wxqrcode='';
        }
      },

      
  }
};
</script>

<style lang="scss" scoped="scoped">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}
.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/adv/adv/part/Basic.vue